var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('h1',{staticClass:"mb-2"},[_vm._v(_vm._s(_vm.$t('withdraws.withdraw_methods.title')))]),_c('WithdrawDataSection',{staticClass:"mb-2"}),_c('WithdrawMethodSection')],1)}
var staticRenderFns = []

export { render, staticRenderFns }